import React from 'react';
import { Icon } from '@makeably/creativex-design-system';

function Separator() {
  return <Icon name="chevronRight" />;
}

export default Separator;
